<template>
  <div class="MarqueeConditional" ref="outer" v-resize="onResize">
    <div
      :class="['inner', { hidden: overflow }]"
      ref="inner"
      v-resize="onInnerResize"
    >
      <div v-html="content"></div>
    </div>
    <Marquee
      v-if="overflow"
      :items="marqueeContent"
      :autoplay="true"
      :instant="true"
      :isHeader="true"
      :isOverflow="this.overflow"
    />
  </div>
</template>

<script>
import Marquee from "@/components/Marquee";
import resize from "vue-resize-directive";

export default {
  name: "MarqueeConditional",
  components: { Marquee },
  directives: { resize },
  props: {
    content: String,
  },
  data() {
    return {
      overflow: false,
    };
  },
  computed: {
    marqueeContent() {
      return [{ text: this.content }, { text: this.content }];
    },
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      let outer = this.$refs.outer;
      let inner = this.$refs.inner;

      const outer_width = outer.offsetWidth;
      const inner_width = inner.offsetWidth;

      if (inner_width > outer_width) {
        if (!this.overflow) {
          this.overflow = true;
        }
      } else {
        if (this.overflow) {
          this.overflow = false;
        }
      }
    },
    onInnerResize() {
      this.onResize();
    },
  },
};
</script>

<style scoped>
.MarqueeConditional {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
}

.inner {
  display: inline-block;
}

.inner.hidden {
  opacity: 0;
}

.marquee-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.MarqueeConditional >>> .marquee-item {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
